/** Get Dashboard Chart data */
export const LOADING = "LOADING";
export const RESULT = "RESULT";

export const GET_VM_STATUS = "DASHBOARD_GET_VM_STATUS";
export const GET_NETT_SETTLEMENT = "DASHBOARD_GET_NETT_SETTLEMENT";
export const GET_SNAPSHOT = "DASHBOARD_SNAPSHOT"